import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import SocialLinks from "@/components/Socials";
import { BUSINESS, NAV, SERVICE_AREAS, IMG } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-coal border-t border-line">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img src={IMG("logo.png")} alt="Park & Spark logo" className="h-11 w-11 object-contain" />
              <span className="leading-none">
                <span className="block font-display text-lg font-bold tracking-wide text-slate-100">
                  PARK &amp; SPARK
                </span>
                <span className="block text-[10px] font-mono font-bold uppercase tracking-[0.3em] text-gold mt-0.5">
                  Mobile Welding, LLC
                </span>
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Family-owned mobile welding and metal fabrication, proudly serving Montana for over
              20 years. {BUSINESS.languages}.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <SocialLinks testIdPrefix="footer-social" boxClass="w-9 h-9" iconSize={15} />
            </div>
          </div>

          <div>
            <h3 className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-gold">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-2">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-400 hover:text-gold transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-gold">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href={BUSINESS.phoneHref}
                  data-testid="footer-phone-link"
                  className="flex items-start gap-2.5 text-slate-200 hover:text-gold transition-colors"
                >
                  <Phone size={15} className="text-gold mt-0.5" aria-hidden="true" />
                  {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS.emailHref}
                  data-testid="footer-email-link"
                  className="flex items-start gap-2.5 text-slate-200 hover:text-gold transition-colors break-all"
                >
                  <Mail size={15} className="text-gold mt-0.5 shrink-0" aria-hidden="true" />
                  {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-slate-400">
                <Clock size={15} className="text-gold mt-0.5 shrink-0" aria-hidden="true" />
                <span>
                  {BUSINESS.hours.map((h) => (
                    <span key={h.days} className="block">
                      {h.days}: {h.time}
                    </span>
                  ))}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-gold">
              Service Area
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {SERVICE_AREAS.map((area) => (
                <li key={area} className="text-sm text-slate-400">
                  {area}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p className="font-mono uppercase tracking-wider">Mobile Welding · Hardin, MT</p>
        </div>
      </div>
    </footer>
  );
}
